import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';
import { FacilityContextService } from './facility-context.service';
import { Observable } from 'rxjs';
import {
  FacilityAttendanceSettings,
  FacilityAttendanceSettingsUpdate,
  FacilityPayPeriodSettings,
  FacilityPayPeriodSetttingsUpdate
} from '../dtos/facility/facility-settings.dto';

@Injectable({ providedIn: 'root' })
export class FacilitySettingsService {
  private http = inject(HttpClient);
  private facilityContext = inject(FacilityContextService);

  private readonly baseUrl = computed(() => {
    return `/api/Facilities/${this.facilityContext.facilityId()}`;
  });

  getPayPeriodSettings(): Observable<
    Partial<FacilityPayPeriodSettings> | undefined
  > {
    return this.http.get<Partial<FacilityPayPeriodSettings> | undefined>(
      `${this.baseUrl()}/pay-period-settings`
    );
  }

  updatePayPeriodSettings(
    facilityPayPeriodSetttingsUpdate: Partial<FacilityPayPeriodSetttingsUpdate>,
    facilityId?: string
  ): Observable<any> {
    const url = facilityId
      ? `/api/Facilities/${facilityId}/pay-period-settings`
      : `${this.baseUrl()}/pay-period-settings`;
    return this.http.put(url, facilityPayPeriodSetttingsUpdate);
  }

  getAttendanceSettings(): Observable<FacilityAttendanceSettings> {
    return this.http.get<FacilityAttendanceSettings>(
      `${this.baseUrl()}/attendance-settings`
    );
  }

  updateAttendanceSettings(
    dto: FacilityAttendanceSettingsUpdate
  ): Observable<FacilityAttendanceSettings> {
    return this.http.put<FacilityAttendanceSettings>(
      `${this.baseUrl()}/attendance-settings`,
      dto
    );
  }
}
